@if (singleItemId === null && !isEditingMode && !isAddMode) {
  <div class="grid mb-2">
    <div class="col-span-12 mb-1 flex justify-center">
      @if (!isEditingMode && !isAddMode) {
        <p-button
          styleClass="p-button-sm"
          (click)="addNewWhereabout()"
          [disabled]="isAddMode"
          icon="pi pi-plus"
          label="{{ 'animalWhereabout.addWhereabout' | transloco }}"
          [rounded]="true"
        />
      }
    </div>
  </div>
}
@if (singleItemId !== null) {
  @if (animalWhereaboutsItems[singleItemId] && !isEditingMode) {
    <div [ngClass]="animalWhereaboutsItems[singleItemId]?.shelterChanged === true ? 'with-shelter-change' : ''">
      <ng-container *ngTemplateOutlet="animalWhereaboutsFormTemplate; context: { key: singleItemId, index: 0 }" />
    </div>
  }
} @else if (animalWhereaboutsItems['dummy'] && !isEditingMode) {
  <ng-container *ngTemplateOutlet="animalWhereaboutsFormTemplate; context: { key: 'dummy', index: 0 }" />
}

<ng-template #animalWhereaboutsFormTemplate let-key="key" let-i="index">
  <p-panel class="mb-4">
    @if (!isEditingMode) {
      <ng-template #header>
        <div class="flex w-full">
          <div class="flex-1 p-2 text-xl font-semibold flex items-center gap-3 flex-wrap">
            @if (key == 'dummy') {
              <h3 class="inline">
                {{ 'animalWhereabout.new' | transloco }}
              </h3>
            }
            @if (
              key !== 'dummy' &&
              animalWhereaboutsItems[key].type &&
              selectedTypeOption[key]
            ) {
              <h3 class="inline">{{ selectedTypeOption[key].name }}</h3>
            }
            @let firstRef =
              animalWhereaboutsItems[key].contacts?.length
                ? animalWhereaboutsItems[key].contacts[0]
                : null;
            @let firstContactId = firstRef?.contact ?? null;
            @if (key !== 'dummy' && firstContactId && contacts[firstContactId]?.city) {
              <h3 class="inline px-1">|</h3>
            }
            @if (key !== 'dummy' && firstContactId && contacts[firstContactId]?.city) {
              <h3 class="inline">{{ contacts[firstContactId].city }}</h3>
            }
            @if (key !== 'dummy' && animalWhereaboutsItems[key].date) {
              <h3 class="inline px-1">|</h3>
            }
            @if (key !== 'dummy' && animalWhereaboutsItems[key].date) {
              <h3 class="inline">{{ animalWhereaboutsItems[key].date | date: 'dd.MM.yyyy' }}</h3>
            }
            @if (key !== 'dummy' && isFoundAnimalReturn(key)) {
              <span class="inline-flex items-center gap-1">
                @if ($any(animalWhereaboutsItems[key]).reportSentOn) {
                  <span class="inline-flex items-center gap-1 text-sm font-normal text-green-600 bg-green-50 border border-green-300 rounded px-2 py-0.5"
                    [pTooltip]="($any(animalWhereaboutsItems[key]).reportSentOn | date: 'dd.MM.yyyy') ?? ''"
                    tooltipPosition="right">
                    <span class="pi pi-check-circle"></span>
                    PDF versendet
                  </span>
                } @else {
                  <span class="inline-flex items-center gap-1 text-sm font-normal text-orange-600 bg-orange-50 border border-orange-300 rounded px-2 py-0.5">
                    <span class="pi pi-exclamation-circle"></span>
                    PDF noch nicht versendet
                  </span>
                }
                @if (sentEmailsByWhereaboutId[$any(animalWhereaboutsItems[key]).id]?.length) {
                  <p-button
                    icon="pi pi-users"
                    [text]="true"
                    [rounded]="true"
                    severity="info"
                    size="small"
                    [pTooltip]="'Empfänger anzeigen'"
                    tooltipPosition="right"
                    (click)="openSentEmailsDialog($event, sentEmailsByWhereaboutId[$any(animalWhereaboutsItems[key]).id])"
                  />
                }
              </span>
            }
          </div>
          @if (key !== 'dummy' && !isFoundAnimalReturn(key)) {
            <div class="flex-none">
              @if (!animalWhereaboutsItems[key].shelterChanged) {
                <p-button
                  (click)="deleteWhereabout(key)"
                  icon="pi pi-trash"
                  severity="danger"
                  [rounded]="true"
                  [raised]="true"
                />
              }
            </div>
          }
        </div>
      </ng-template>
    }
    <div class="col-span-12">
      <p-accordion [multiple]="true" [value]="['0', '1', '2', 'bcs', 'sentEmails']">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <div class="flex justify-between w-full items-center mr-2">
              <span class="order-0">
                {{ 'animalDetails.general.headline' | transloco }}
                @if (key === 'dummy' && !selectedTypeOption['dummy']) {
                  <span
                    class="pi pi-exclamation-triangle text-red-400"
                    [pTooltip]="'animalAdd.general.invalidTooltip' | transloco"
                    tooltipPosition="right"
                  ></span>
                }
              </span>
              <span>
                @if (key !== 'dummy' && isFoundAnimalReturn(key)) {
                  <p-button
                    icon="pi pi-send"
                    class="p-button-sm"
                    [text]="true"
                    [rounded]="true"
                    [raised]="true"
                    [label]="'pickUpReport.sendPdf' | transloco"
                    (click)="openSendPickupReport($event, key)"
                  />
                  @if ($any(animalWhereaboutsItems[key]).reportPdfPath) {
                    <p-button
                      icon="pi pi-file-pdf"
                      class="p-button-sm"
                      [text]="true"
                      [rounded]="true"
                      [raised]="true"
                      [label]="'pickUpReport.showPdf' | transloco"
                      (click)="openPickupPdf($event, key)"
                    />
                  }
                }
                @if (key !== 'dummy' && !isFoundAnimalReturn(key)) {
                  <p-button
                    icon="pi pi-pen-to-square"
                    class="p-button-sm"
                    [text]="true"
                    [rounded]="true"
                    [raised]="true"
                    (click)="toggleEditDialog(true, 'general', key)"
                  />
                }
              </span>
            </div>
          </p-accordion-header>
          <p-accordion-content>
            @if (isFoundAnimalReturn(key)) {
              <ng-container
                *ngTemplateOutlet="
                  pickupReportDisplay;
                  context: { whereAbout: animalWhereaboutsItems[key] }
                "
              />
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  generalForm;
                  context: { whereAbout: animalWhereaboutsItems[key] }
                "
              />
            }
          </p-accordion-content>
        </p-accordion-panel>

        @if (isFoundAnimalReturn(key) && ($any(animalWhereaboutsItems[key]).careCondition?.length || $any(animalWhereaboutsItems[key]).bcsNutrition || $any(animalWhereaboutsItems[key]).temperament?.length)) {
          <p-accordion-panel value="bcs">
            <p-accordion-header>Fundtier Zustand</p-accordion-header>
            <p-accordion-content>
              <div class="grid grid-cols-12 gap-2">
                @if ($any(animalWhereaboutsItems[key]).careCondition?.length) {
                  <div class="col-span-12">
                    <label>{{ 'animalAdd.origin.conditionOfCare.headline' | transloco }}</label>
                    <div class="w-full flex flex-wrap gap-2 p-2">
                      @for (c of $any(animalWhereaboutsItems[key]).careCondition; track c) {
                        <p-chip [label]="getCareLabel(c)" />
                      }
                    </div>
                  </div>
                }
                @if ($any(animalWhereaboutsItems[key]).bcsNutrition) {
                  <div class="col-span-12">
                    <label>{{ 'animalAdd.origin.nutritionalStatus.headline' | transloco }}</label>
                    <div class="w-full flex flex-wrap gap-2 p-2">
                      <p-chip [label]="getNutritionLabel($any(animalWhereaboutsItems[key]).bcsNutrition)" />
                    </div>
                  </div>
                }
                @if ($any(animalWhereaboutsItems[key]).temperament?.length) {
                  <div class="col-span-12">
                    <label>{{ 'animalAdd.general.foundAnimal.temperament' | transloco }}</label>
                    <div class="w-full flex flex-wrap gap-2 p-2">
                      @for (t of $any(animalWhereaboutsItems[key]).temperament; track t) {
                        <p-chip [label]="getTemperamentLabel(t)" />
                      }
                    </div>
                  </div>
                }
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (isFoundAnimalReturn(key) && (sentEmailsByWhereaboutId[$any(animalWhereaboutsItems[key]).id]?.length || animalWhereaboutsItems[key].authorityInformation)) {
          <p-accordion-panel value="sentEmails">
            <p-accordion-header>Versendete E-Mails</p-accordion-header>
            <p-accordion-content>
              @if (animalWhereaboutsItems[key].authorityInformation) {
                <div class="text-sm text-gray-600 bg-gray-50 rounded p-2 mb-2 whitespace-pre-wrap">{{ animalWhereaboutsItems[key].authorityInformation }}</div>
              }
              <div class="flex flex-col gap-1 p-1">
                @for (email of sentEmailsByWhereaboutId[$any(animalWhereaboutsItems[key]).id]; track email.id) {
                  <div class="text-sm text-gray-700">
                    @if (email.recipientName) {
                      <span class="font-medium">{{ email.recipientName }}: </span>
                    }
                    <span>{{ email.recipientEmail }}</span>
                    <span class="text-gray-400 ml-2">{{ email.sentAt | date: 'dd.MM.yyyy HH:mm' }}</span>
                  </div>
                }
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (!animalWhereaboutsItems[key].shelterChanged) {
          <p-accordion-panel value="1">
            <p-accordion-header>
              <div class="flex mr-2 justify-between w-full items-center">
                <span class="order-0">
                  @if (key === 'dummy' && isFoundAnimalReturnSelected) {
                    {{ 'pickUpReport.confirm.title' | transloco }}
                  } @else {
                    {{ 'animalDetails.general.contact' | transloco }}
                  }
                </span>
                @if (key !== 'dummy' && !isFoundAnimalReturn(key)) {
                  <span class="flex gap-2">
                    <p-button
                      (click)="toggleEditDialog(true, 'contactRef', key, null)"
                      icon="pi pi-plus"
                      class="p-button-sm"
                      [text]="true"
                      [rounded]="true"
                      [raised]="true"
                      [pTooltip]="'contacts.add' | transloco"
                      tooltipPosition="top"
                    />
                  </span>
                }
                @if (key === 'dummy' && !isFoundAnimalReturnSelected) {
                  <span class="flex gap-2">
                    <p-button
                      (click)="openDummyContactDialog(null)"
                      icon="pi pi-plus"
                      class="p-button-sm"
                      [text]="true"
                      [rounded]="true"
                      [raised]="true"
                      [pTooltip]="'contacts.add' | transloco"
                      tooltipPosition="top"
                    />
                  </span>
                }
              </div>
            </p-accordion-header>

            <p-accordion-content>
              @let refs = animalWhereaboutsItems[key].contacts ?? [];

              @if (key !== 'dummy' && (!refs || refs.length === 0)) {
                <span>{{ 'contacts.noContactExist' | transloco }}</span>
              }

              @if (key !== 'dummy' && refs?.length) {
                <div class="flex flex-col gap-4">
                  @for (ref of refs; track ref; let refIndex = $index) {
                    @let contactId = ref.contact ?? null;

                    <div class="rounded border border-gray-200 p-2">
                      <!-- Title row -->
                      <div class="flex items-center justify-between gap-2 mb-2">
                        <div class="font-semibold">
                          <!-- Überschrift dynamisch über type -->
                          {{ 'animalContact.types.' + ref.type | transloco }}
                          @if (ref.label) {
                            <span class="font-normal text-gray-500"
                              >— {{ ref.label }}</span
                            >
                          }
                          @if (ref.isPrimary) {
                            <span class="ml-2 text-xs text-gray-500"
                              >(Primary)</span
                            >
                          }
                        </div>

                        <div class="flex gap-2">
                          @if (contactId) {
                            <p-button
                              [routerLink]="['/kontakte', contactId]"
                              icon="pi pi-eye"
                              [text]="true"
                              [rounded]="true"
                              [raised]="true"
                            />
                          }
                          @if (!isFoundAnimalReturn(key)) {
                            <p-button
                              (click)="
                                toggleEditDialog(
                                  true,
                                  'contactRef',
                                  key,
                                  refIndex
                                )
                              "
                              icon="pi pi-pen-to-square"
                              [text]="true"
                              [rounded]="true"
                              [raised]="true"
                            />
                          }
                        </div>
                      </div>

                      <!-- Content -->
                      @if (contactId && contacts[contactId]) {
                        <ng-container
                          *ngTemplateOutlet="
                            contactForm;
                            context: { contact: contacts[contactId] }
                          "
                        />
                      } @else if (contactId && !contacts[contactId]) {
                        <span class="text-gray-500">
                          {{ 'contacts.loading' | transloco }}
                        </span>
                      } @else {
                        <span class="text-gray-500">
                          {{ 'contacts.noContactSelected' | transloco }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }

              @if (key === 'dummy' && !isFoundAnimalReturnSelected) {
                <div class="flex flex-col gap-4">
                  @if (dummyContactRefs.length === 0) {
                    <span class="text-gray-500">{{ 'contacts.noContactExist' | transloco }}</span>
                  }
                  @for (entry of dummyContactRefs; track $index; let entryIdx = $index) {
                    <div class="rounded border border-gray-200 p-2">
                      <div class="flex items-center justify-between gap-2 mb-2">
                        <div class="font-semibold">
                          {{ 'animalContact.types.' + entry.ref.type | transloco }}
                          @if (entry.ref.label) {
                            <span class="font-normal text-gray-500">— {{ entry.ref.label }}</span>
                          }
                        </div>
                        <div class="flex gap-2">
                          @if (entry.contact?.id; as entryContactId) {
                            <p-button
                              [routerLink]="['/kontakte', entryContactId]"
                              icon="pi pi-eye"
                              [text]="true"
                              [rounded]="true"
                              [raised]="true"
                            />
                          }
                          <p-button
                            icon="pi pi-pen-to-square"
                            [text]="true"
                            [rounded]="true"
                            [raised]="true"
                            (click)="openDummyContactDialog(entryIdx)"
                          />
                          <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [text]="true"
                            [rounded]="true"
                            [raised]="true"
                            (click)="removeDummyContactRef(entryIdx)"
                          />
                        </div>
                      </div>
                      @if (entry.contact) {
                        <ng-container
                          *ngTemplateOutlet="
                            contactForm;
                            context: { contact: entry.contact }
                          "
                        />
                      } @else {
                        <span class="text-sm text-gray-400 italic">{{ 'contacts.noContactSelected' | transloco }}</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (key === 'dummy' && isFoundAnimalReturnSelected) {
                <div class="flex justify-center my-6">
                  <p-button
                    icon="pi pi-play"
                    [label]="'pickUpReport.startButton' | transloco"
                    (click)="openPickUpReportConfirm()"
                  />
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (animalWhereaboutsItems[key].shelterChanged) {
          <p-accordion-panel value="2">
            <p-accordion-header>
              <div class="flex justify-between w-full items-center">
                <span class="order-0">
                  {{ 'animalDetails.general.shelter.title' | transloco }}
                </span>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              @if (
                animalSheltersById[
                  animalWhereaboutsItems[key].animalShelter?.id
                ];
                as shelter
              ) {
                <div class="grid gap-2">
                  <div class="col-span-12">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelter">
                          {{
                            'animalDetails.general.shelter.title' | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.title"
                          id="animalShelter"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-4">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelterAddress">
                          {{
                            'animalDetails.general.shelter.address' | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.address"
                          id="animalShelterAddress"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-4">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelterZipCode">
                          {{
                            'animalDetails.general.shelter.zipCode' | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.zipCode"
                          id="animalShelterZipCode"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-4">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelterCity">
                          {{ 'animalDetails.general.shelter.city' | transloco }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.city"
                          id="animalShelterCity"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelterPhoneNumber">
                          {{
                            'animalDetails.general.shelter.phoneNumber'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.phoneNumber"
                          id="animalShelterPhoneNumber"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="animalShelterMailAddress">
                          {{
                            'animalDetails.general.shelter.mailAddress'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          [class.no-border]="!isEditingMode"
                          pInputText
                          [value]="shelter.mailAddress"
                          id="animalShelterMailAddress"
                          disabled
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>

    @if (key == 'dummy') {
    <div class="flex w-full justify-end gap-2 p-2">

      <p-button
      (click)="cancelNewWhereabout()"
      label="{{ 'modal.cancel' | transloco }}"
      icon="pi pi-times"
      [text]="true"
      />
      @if (key == 'dummy' && !isFoundAnimalReturnSelected) {
        <p-button
        label="{{ 'modal.save' | transloco }}"
        (click)="saveNewWhereabout()"
        icon="pi pi-save"
        [disabled]="!selectedTypeOption['dummy']"
        />
      }
    </div>
  }
  </p-panel>
</ng-template>

<ng-template #generalForm let-whereAbout="whereAbout">
  <div class="grid grid-cols-12 gap-2">
    <div class="col-span-12">
      <p-inputgroup>
        <p-iftalabel>
          <label for="type">
            {{ 'animalWhereabout.type.headline' | transloco }}
            @if (isEditingMode || isAddMode) {
              <span class="required text-red-400">*</span>
            }
          </label>
          @if (isEditingMode || isAddMode) {
            <p-select
              class="p-inputdropdown-sm w-full"
              id="type"
              [options]="whereAboutTypeOptions"
              optionLabel="name"
              [(ngModel)]="selectedTypeOption[whereAbout.id]"
              (ngModelChange)="whereAbout.id === 'dummy' ? onDummyTypeChange($event) : null"
              appendTo="body"
              [disabled]="!isEditingMode && !isAddMode"
              [required]="true"
              [ngClass]="{'!border-red-500': !selectedTypeOption[whereAbout.id]}"
            >
              <ng-template #selectedItem>
                @if (selectedTypeOption[whereAbout.id]) {
                  {{ selectedTypeOption[whereAbout.id].name | transloco }}
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                {{ option.name | transloco }}
              </ng-template>
            </p-select>
          }
          @if (
            !isEditingMode && !isAddMode && selectedTypeOption[whereAbout.id]
          ) {
            <input
              type="text"
              class="w-full p-inputtext-sm no-border"
              pInputText
              [value]="selectedTypeOption[whereAbout.id].name"
              id="type"
              disabled
            />
          }
        </p-iftalabel>
      </p-inputgroup>
    </div>
    @if (whereAbout.id !== 'dummy' || !isFoundAnimalReturnSelected) {
    <div class="col-span-12">
      <p-inputgroup>
        <p-iftalabel>
          <label for="type">
            {{ 'animalWhereabout.discoverySource.headline' | transloco }}
          </label>
          @if (isEditingMode || isAddMode) {
            <p-select
              id="type"
              [options]="discoverSourceOptions"
              optionLabel="name"
              [(ngModel)]="selectedDiscoveryOption[whereAbout.id]"
              appendTo="body"
              [disabled]="!isEditingMode && !isAddMode"
              [placeholder]="
                'animalWhereabout.discoverySource.null' | transloco
              "
            >
              <ng-template #selectedItem>
                @if (selectedDiscoveryOption[whereAbout.id]) {
                  {{ selectedDiscoveryOption[whereAbout.id].name | transloco }}
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                {{ option.name | transloco }}
              </ng-template>
            </p-select>
          }
          @if (
            !isEditingMode &&
            !isAddMode &&
            selectedDiscoveryOption[whereAbout.id]
          ) {
            <input
              type="text"
              class="w-full p-inputtext-sm no-border"
              pInputText
              [value]="selectedDiscoveryOption[whereAbout.id].name"
              id="type"
              disabled
            />
          }
        </p-iftalabel>
      </p-inputgroup>
    </div>
    <div class="col-span-6">
      @if (isEditingMode || isAddMode) {
        <app-custom-date-picker
          id="date"
          [label]="'animalWhereabout.date'"
          [rawInput]="
            whereAbout.date ? (whereAbout.date | date: 'yyyy-MM-dd') + '' : null
          "
          (valueChange)="whereAbout.date = $event"
          [disabled]="!isEditingMode && !isAddMode"
        />
      }
      @if (!isEditingMode && !isAddMode) {
        <p-inputgroup>
          <p-iftalabel>
            <label for="date">
              {{ 'animalWhereabout.date' | transloco }}
            </label>
            <input
              type="text"
              class="w-full p-inputtext-sm no-border"
              pInputText
              [value]="
                whereAbout.date ? (whereAbout.date | date: 'dd.MM.yyyy') : ''
              "
              id="date"
              disabled
            />
          </p-iftalabel>
        </p-inputgroup>
      }
    </div>
    <div class="col-span-6">
      @if (isEditingMode || isAddMode) {
        <app-custom-date-picker
          id="dateCare"
          [label]="'animalWhereabout.dateCare'"
          [rawInput]="
            whereAbout.dateCare
              ? (whereAbout.dateCare | date: 'yyyy-MM-dd') + ''
              : null
          "
          (valueChange)="whereAbout.dateCare = $event"
          [disabled]="!isEditingMode && !isAddMode"
        />
      }
      @if (!isEditingMode && !isAddMode) {
        <p-inputgroup>
          <p-iftalabel>
            <label for="dateCare">
              {{ 'animalWhereabout.dateCare' | transloco }}
            </label>
            <input
              type="text"
              class="w-full p-inputtext-sm no-border"
              pInputText
              [value]="
                whereAbout.dateCare
                  ? (whereAbout.dateCare | date: 'dd.MM.yyyy')
                  : ''
              "
              id="dateCare"
              disabled
            />
          </p-iftalabel>
        </p-inputgroup>
      }
    </div>
    @if (isEditingMode || isAddMode || whereAbout.information) {
      <div class="col-span-12">
        <p-inputgroup>
          <p-iftalabel>
            <label for="information">
              {{ 'animalWhereabout.information' | transloco }}
            </label>
            <textarea
              pInputText
              area
              [class.no-border]="!isEditingMode && !isAddMode"
              class="p-inputtext-sm w-full"
              [(ngModel)]="whereAbout.information"
              id="information"
              rows="5"
              [disabled]="!isEditingMode && !isAddMode"
            ></textarea>
          </p-iftalabel>
        </p-inputgroup>
      </div>
    }
    @if (isEditingMode || isAddMode || whereAbout.externalDescription) {
      <div class="col-span-12">
        <p-inputgroup>
          <p-iftalabel>
            <label for="externalDescription">
              {{ 'animalWhereabout.externalDescription' | transloco }}
            </label>
            <textarea
              pInputText
              area
              [class.no-border]="!isEditingMode && !isAddMode"
              class="p-inputtext-sm w-full"
              [(ngModel)]="whereAbout.externalDescription"
              id="externalDescription"
              rows="5"
              [disabled]="!isEditingMode && !isAddMode"
            ></textarea>
          </p-iftalabel>
        </p-inputgroup>
      </div>
    }
    }
  </div>
</ng-template>

<ng-template #contactForm let-contact="contact">
  @if (contact) {
    <div class="grid grid-cols-12 gap-2">
      @if (contact.gender) {
        <div class="col-span-3">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personSalutation">
                {{ 'animalAdd.origin.person.salutation' | transloco }}
              </label>
              <p-select
                class="p-inputdropdown-sm w-full"
                [options]="personSalutationOptions"
                optionLabel="name"
                optionValue="value"
                [(ngModel)]="contact.gender"
                id="personSalutation"
                appendTo="body"
                [disabled]="true"
              >
              </p-select>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.lastName) {
        <div class="col-span-4">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personLastName">
                {{ 'animalAdd.origin.person.lastName' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.lastName"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.firstName) {
        <div class="col-span-5">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personFirstName">
                {{ 'animalAdd.origin.person.firstName' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.firstName"
                id="personFirstName"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.companyName) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="companyName">
                {{ 'animalAdd.origin.person.companyName' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.companyName"
                id="companyName"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.street) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personStreet">
                {{ 'animalAdd.origin.person.street' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.street"
                id="personStreet"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.zipCode) {
        <div class="col-span-2">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personZipCode">
                {{ 'animalAdd.origin.person.zipCode' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.zipCode"
                id="personZipCode"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.city) {
        <div class="col-span-4">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personCity">
                {{ 'animalAdd.origin.person.city' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.city"
                id="personCity"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.phoneNumbers?.length) {
        @for (entry of contact.phoneNumbers; track entry; let index = $index) {
          <div class="col-span-6 col-start-1">
            <p-inputgroup>
              <p-iftalabel>
                @if (entry.type === phoneNumbersEntryType.MOBILE) {
                  <label [for]="'number' + index">
                    {{ 'animalAdd.origin.person.mobileNumber' | transloco }}
                  </label>
                } @else if (entry) {}
                @switch (entry.type) {
                  @case (phoneNumbersEntryType.MOBILE) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.mobileNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.PRIVATE) {
                    <label for="personNumber">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.BUSINESS) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.businessNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.CUSTOM) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                  @default {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                }
                <input
                  type="text"
                  class="no-border"
                  [value]="entry.number"
                  [id]="'number' + index"
                  pInputText
                  [disabled]="true"
                />
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <div class="col-span-6">
            <p-inputgroup>
              <p-iftalabel>
                <label [for]="'personMobileNumberName' + index">
                  {{ 'animalAdd.origin.person.mobileNumberName' | transloco }}
                </label>
                <input
                  type="text"
                  class="no-border"
                  [value]="entry.label"
                  [id]="'personMobileNumberName' + index"
                  pInputText
                  [disabled]="true"
                />
              </p-iftalabel>
            </p-inputgroup>
          </div>
        }
      }
      @if (contact.email) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              @if (contact.email) {
                <a
                  class="absolute"
                  [href]="'mailto:' + contact.email"
                  [pTooltip]="'animalAdd.origin.person.email' | transloco"
                  tooltipPosition="top"
                >
                  <i class="pi pi-envelope"></i>
                </a>
              }
            </p-inputgroup-addon>
            <p-iftalabel>
              <label for="personEmail">
                {{ 'animalAdd.origin.person.email' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.email"
                id="personEmail"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.url) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              @if (contact.url) {
                <a
                  class="relative w-full h-full flex items-center justify-center"
                  target="_blank"
                  [href]="contact.url"
                  [pTooltip]="'animalAdd.origin.person.url' | transloco"
                  tooltipPosition="top"
                >
                  <i class="pi pi-globe"></i>
                </a>
              }
            </p-inputgroup-addon>
            <p-iftalabel>
              <label for="personUrl">
                {{ 'animalAdd.origin.person.url' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.url"
                id="personUrl"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.idCardNumber) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personIdCardNumber">
                {{ 'animalAdd.origin.person.idCardNumber' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.idCardNumber"
                id="personIdCardNumber"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.birthday) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personBirthday">
                {{ 'animalAdd.origin.person.birthday' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.birthday | date: 'dd.MM.yyyy'"
                id="personBirthday"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.birthPlace) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personBirthPlace">
                {{ 'animalAdd.origin.person.birthplace' | transloco }}
              </label>
              <input
                type="text"
                class="w-full p-inputtext-sm no-border"
                [disabled]="true"
                [value]="contact.birthPlace"
                id="personBirthPlace"
                pInputText
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
    </div>
  }
</ng-template>

<p-dialog
  [(visible)]="openEdit"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="toggleEditDialog(false, '', null, null)"
>
  <ng-template #closeicon>
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template #header>
    <div class="flex items-center">
      <div class="px-4">
        <app-animal-current-category [animal]="animal" />
      </div>
      <div class="flex px-4 animal-name-headline">
        @if (animal) {
          <app-animal-in-stock-icon [animal]="animal" />
        }
        {{ animal.displayName }}
      </div>
      <div class="flex px-4 justify-center items-center">
        <img
          src="../../../../assets/images/icons/icon_key_green.svg"
          alt="key"
        />
        <p>
          {{ animal.bookNumber }}
          @if (animal.oldBookNumber) {
            <span>({{ animal.oldBookNumber }})</span>
          }
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-panel class="p-2">
      @if (editType === 'general') {
        <ng-template #header>
          <span class="flex items-center gap-1 font-semibold">
            {{ 'animalDetails.general.headline' | transloco }}
            @if (!selectedTypeOption[editingItem?.id]) {
              <span
                class="pi pi-exclamation-triangle text-red-400"
                [pTooltip]="'animalAdd.general.invalidTooltip' | transloco"
                tooltipPosition="right"
              ></span>
            }
          </span>
        </ng-template>
      }
      @if (editType === 'general') {
        <ng-container
          *ngTemplateOutlet="
            generalForm;
            context: { key: editDialogWhereAboutKey, whereAbout: editingItem }
          "
        />
      }
      @if (editType === 'contactRef' && editingContactRef) {
        <div class="grid grid-cols-12 gap-2 mb-4">
          <div class="col-span-6">
            <p-iftalabel>
              <label>{{ 'animalContact.type' | transloco }}</label>
              <p-select
                class="w-full"
                [options]="contactTypeOptions"
                optionLabel="name"
                optionValue="value"
                [(ngModel)]="editingContactRef.type"
                appendTo="body"
              />
            </p-iftalabel>
          </div>
          <div class="col-span-6">
            <p-iftalabel>
              <label>{{ 'animalContact.label' | transloco }}</label>
              <input
                pInputText
                class="w-full"
                [(ngModel)]="editingContactRef.label"
              />
            </p-iftalabel>
          </div>
        </div>
        <app-choose-contact
          [allowEmptyValid]="true"
          [newContact]="editingItem"
          [isExistingContact]="existingContact"
          (newContactUpdated)="onContactUpdate($event)"
          (validationStatusChanged)="onValidationStatusChanged($event)"
          (existingContactSelected)="onExistingContactSelected($event)"
        />
      }
    </p-panel>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="toggleEditDialog(false, '', null, null)"
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
      />
      <p-button
        (click)="save(editingItem)"
        [disabled]="!validationStatusChanged || (editType === 'general' && !selectedTypeOption[editingItem?.id])"
        icon="pi pi-save"
        label="{{ 'modal.save' | transloco }}"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Fundtier Abholung: Bestätigung Datenlage -->
<p-dialog
  [(visible)]="confirmDataDialogVisible"
  [modal]="true"
  [style]="{ width: '420px' }"
  [blockScroll]="true"
  [header]="'pickUpReport.confirm.title' | transloco"
  [resizable]="false"
  [draggable]="false"
>
  <p>{{ 'pickUpReport.confirm.question' | transloco }}</p>
  <ng-template pTemplate="footer">
    <p-button
      [label]="'general.close' | transloco"
      [text]="true"
      (click)="confirmDataDialogVisible = false"
    />
    <p-button
      [label]="'pickUpReport.confirm.yes' | transloco"
      icon="pi pi-check"
      (click)="onConfirmDataCurrent()"
    />
  </ng-template>
</p-dialog>

<!-- Fundtier Abholung: Wizard -->
<app-pick-up-report-dialog
  [animal]="animal"
  [(visible)]="pickUpReportDialogVisible"
  (completed)="onPickUpReportCompleted()"
/>

<!-- Fundtier Abholung: PDF anzeigen -->
<p-dialog
  [(visible)]="pickupPdfDialogVisible"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '80vw', height: '90vh' }"
  [header]="'pickUpReport.showPdf' | transloco"
  [resizable]="false"
  [draggable]="false"
>
  <app-pdf-viewer [pdf]="pickupPdfBlob ?? undefined" height="70vh" />
</p-dialog>

<!-- Fundtier Abholung: PDF versenden -->
@if (sendPickupReportDialogVisible && sendPickupReportWhereaboutId) {
  <app-send-found-report-dialog
    [(visible)]="sendPickupReportDialogVisible"
    [id]="sendPickupReportWhereaboutId"
    [animal]="animal"
    [availableContacts]="sendPickupReportContacts"
    [sendFn]="sendPickupReportFn"
    [authorityInformation]="sendPickupReportAuthorityInformation"
    (sent)="onSendPickupReportSent($event)"
  />
}

<!-- Pickup-Report Anzeige (read-only) -->
<ng-template #pickupReportDisplay let-whereAbout="whereAbout">
  <div class="grid grid-cols-12 gap-2">

    <!-- Typ (read-only) -->
    <div class="col-span-12">
      <p-inputgroup>
        <p-iftalabel>
          <label>{{ 'animalWhereabout.type.headline' | transloco }}</label>
          <input
            type="text"
            class="w-full p-inputtext-sm no-border"
            pInputText
            [value]="selectedTypeOption[whereAbout.id]?.name ?? ''"
            disabled
          />
        </p-iftalabel>
      </p-inputgroup>
    </div>

    <!-- Abholzeitpunkt -->
    @if ($any(whereAbout).pickupDateTime) {
      <div class="col-span-6">
        <p-inputgroup>
          <p-iftalabel>
            <label>{{ 'pickUpReport.form.pickupDateTime' | transloco }}</label>
            <input
              type="text"
              class="w-full p-inputtext-sm no-border"
              pInputText
              [value]="$any(whereAbout).pickupDateTime | date: 'dd.MM.yyyy HH:mm'"
              disabled
            />
          </p-iftalabel>
        </p-inputgroup>
      </div>
    }

  </div>
</ng-template>

<app-sent-emails-dialog
  [(visible)]="sentEmailsDialogVisible"
  [emails]="sentEmailsDialogData"
/>

